<template lang="pug">
#filtros-novo-monitoramento.view-container
    .filtros
        .pesquisa-inteligente__container
            .pesquisa-inteligente__barra-pesquisa
                i.el-icon-search
                input(
                    v-model='pesquisa',
                    type='text',
                    :placeholder='placeholderPais()',
                    autocomplete='off',
                    @keyup.enter='pesquisar',
                    @blur='fecharLista'
                )

            .pesquisa-inteligente__resultado
                transition(name='el-zoom-in-top')
                    ul.pesquisa-inteligente__ul(v-if='mostrarOpcoes')
                        .mb-2(v-for='opcao in opcoes')
                            span.pesquisa-inteligente__categoria(
                                v-if='opcao.resultado.length'
                            ) {{ opcao.categoria }}

                            li(
                                v-for='resultado in opcao.resultado',
                                @click='selecionarResultado(resultado, opcao.codigo)'
                            )
                                span {{ resultado.valor }}

        .filtros-avancados
            el-popover(placement='bottom', width='500', trigger='click')
                BaseButton.button-outline(
                    type='outline'
                    icon='lyra-icon lyra-filtro',
                    name='filtro',
                    plain,
                    slot='reference'
                ) {{ $t('mensagens.blocoFiltros.uteis.filtrosAvancados') }}

                el-form.filtro(label-position='top')
                    .filtros-avancados__cabecalho.mb-3
                        .filtros-avancados__titulo
                            b {{ $t('mensagens.blocoFiltros.uteis.filtrosAvancados') }}
                        .filtros-avancados__aplicar-filtro(
                            @click='aplicarFiltros'
                        )
                            | {{ $t('mensagens.blocoFiltros.uteis.aplicarFiltros') }}

                    .filtros-avancados__collapse
                        el-form-item
                            el-collapse(
                                v-model='collapseFiltroAvancado',
                                accordion,
                                @change='abrirCollapse'
                            )
                                el-collapse-item(v-if="usuarioLogado.paisGrupo === ambientes.BRASIL" :title="$t('mensagens.comuns.biomas')", name='biomas')
                                    .el-collapse-item__biomas(
                                        v-loading='!biomas.length'
                                    )
                                        el-radio(
                                            v-for='(bioma, index) in biomas',
                                            v-model='biomaSelecionado',
                                            :label='bioma',
                                            :key='index + bioma.nome'
                                        )
                                            | {{ bioma.nome }}

                                el-collapse-item(
                                    :title='$t("mensagens.blocoFiltros.uteis.ufMunicipio")',
                                    name='localidadesNivel0',
                                    style='padding-bottom: 10px'
                                )
                                    .filtros-avancados-popover__select(
                                        v-loading='!localidadesNivel0.length'
                                    )
                                        div
                                            p {{ $t('mensagens.comuns.pais') }}
                                            el-select(
                                                v-model='localidadeNivel0Selecionada',
                                                filterable,
                                                value-key='id',
                                                @change='buscarLocalidadeNivel1()',
                                                :placeholder='$t("mensagens.comuns.selecione")'
                                            )
                                                el-option(
                                                    v-for='(localidadeNivel0, index) in localidadesNivel0',
                                                    :key='index',
                                                    :label='localidadeNivel0.nome',
                                                    :value='localidadeNivel0'
                                                ) {{ localidadeNivel0.nome }}
                                        div
                                            p {{ tituloLocalidadeNivel1 }}
                                            el-select(
                                                v-model='localidadeNivel1Selecionada',
                                                filterable,
                                                value-key='id',
                                                @change='buscarLocalidadeNivel2()',
                                                :placeholder='$t("mensagens.comuns.selecione")'
                                            )
                                                el-option(
                                                    v-for='(localidadeNivel1, index) in localidadesNivel1',
                                                    :key='index',
                                                    :label='localidadeNivel1.nome',
                                                    :value='localidadeNivel1'
                                                ) {{ localidadeNivel1.nome }}
                                        div
                                            p {{ tituloLocalidadeNivel2 }}
                                            el-select(
                                                v-model='localidadeNivel2Selecionada',
                                                filterable,
                                                value-key='id',
                                                :placeholder='$t("mensagens.comuns.selecione")'
                                            )
                                                el-option(
                                                    v-for='(localidadeNivel2, index) in localidadesNivel2',
                                                    :key='localidadeNivel2.id',
                                                    :label='localidadeNivel2.nome',
                                                    :value='localidadeNivel2'
                                                ) {{ localidadeNivel2.nome }}

    .pesquisa-inteligente-novo-monitoramento__filtros-selecionados.mt-3
        span.filtros-selecionados__titulo {{ $t('mensagens.blocoFiltros.uteis.filtrosSelecionados') }}:
        el-tag.filtros-selecionados__tags(
            v-for='tag in tags',
            :key='tag.nome',
            closable='',
            type='success',
            @close='removerFiltro(tag)'
        )
            span {{ tag.nome }}

        el-tag.filtros-selecionados__limpar(
            v-if='tags.length',
            type='info',
            @click='limparFiltros'
        ) {{ $t('mensagens.blocoFiltros.uteis.limparFiltros') }}
            i.el-icon-delete

        span.filtros-selecionados__vazio(v-else) {{ $t('mensagens.blocoFiltros.uteis.nenhumFiltroSelecionado') }}
</template>

<script>
import FomularioFiltroAvancadoMonitoramento from '@/components/monitoramento/FomularioFiltroAvancadoMonitoramento';
import PesquisaInteligenteService from '@/services/PesquisaInteligenteService';
import BiomaService from '@/services/BiomaService';
import LocalidadeService from '@/services/LocalidadeService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import { mapState } from 'vuex';
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';

export default {
    name: 'FiltrarTerritorioMonitoramentoParaguai',
    props: {
        isMonitoramentoSocioambiental: {
            type: Boolean,
            default: () => false
        }
    },
    computed: {
        ...mapState(['usuarioLogado'])
    },
    components: {
        FomularioFiltroAvancadoMonitoramento,
        BaseButton
    },
    data() {
        return {
            pesquisa: '',
            opcoes: [],
            mostrarOpcoes: false,
            collapseFiltroAvancado: '',

            biomas: [],
            biomaSelecionado: '',
            localidadesNivel0: [],
            localidadeNivel0Selecionada: {},
            tituloLocalidadeNivel1: this.$t('mensagens.blocoFiltros.uteis.uf'),
            localidadesNivel1: [],
            localidadeNivel1Selecionada: '',
            tituloLocalidadeNivel2: this.$t('mensagens.blocoFiltros.uteis.municipio'),
            localidadesNivel2: [],
            localidadeNivel2Selecionada: '',
            tags: [],
            resultadosSelecionados: [],
            acaoCollapse: {
                biomas: {
                    collapse: 'biomas',
                    callback: 'buscarBiomas'
                },
                localidadesNivel0: {
                    collapse: 'localidadesNivel0',
                    callback: 'buscarLocalidadeNivel0'
                },
                localidadesNivel1: {
                    collapse: 'localidadesNivel1',
                    callback: 'buscarLocalidadeNivel1'
                }
            },
            ambientes: AmbientesEmpresas
        };
    },
    mounted() {
        this.validarRotaComParametro();
        this.validarRotaSemParametro();
    },
    watch: {
        '$i18n.locale': function(newLocale) {
            this.internacionalizarLocalidade();
        },

        localidadeNivel0Selecionada: function() {
            if (Object.entries(this.localidadeNivel0Selecionada).length === 0) {
                this.localidadeNivel0Selecionada = this.localidadesNivel0[1];
                this.buscarLocalidadeNivel1();
            }

            this.internacionalizarLocalidade();
        }
    },
    methods: {
        async pesquisar() {
            const { data } =
                await PesquisaInteligenteService.realizarPesquisaTerritorios(
                    this.pesquisa
                );
            this.opcoes = data;

            let resultadoValido = false;
            for (const opcao of this.opcoes) {
                if (opcao.resultado.length !== 0) {
                    resultadoValido = true;
                    break;
                }
            }
            this.mostrarOpcoes = !!resultadoValido;

            if (!this.mostrarOpcoes) {
                this.$notify.warning({
                    message:
                        'Não foram encontrados resultados com o texto informado'
                });
            }
        },

        fecharLista() {
            setTimeout(() => {
                this.mostrarOpcoes = false;
            }, 300);
        },

        selecionarResultado(resultado, categoria) {
            this.adicionarResultado(resultado, categoria);
            this.pesquisa = '';
            this.aplicarFiltros();
        },

        adicionarResultado(resultado, categoria) {
            const filtro = {
                categoria: categoria,
                id: resultado.id,
                nome: resultado.valor
            };
            filtro.codigo = `${filtro.id}_${filtro.nome}`;

            const adicionado = this.resultadosSelecionados.find(
                c => c.codigo === filtro.codigo
            );

            if (!adicionado) {
                this.resultadosSelecionados.push(filtro);
            }
        },

        aplicarFiltros() {

            const filtros = {
                idTerritorios: this.resultadosSelecionados
                    .filter(t => t.categoria === 'TERRITORIO')
                    .map(t => t.id),
                idRepresentantes: this.resultadosSelecionados
                    .filter(r => r.categoria === 'REPRESENTANTE')
                    .map(r => r.id),
                idNivel0: this.resultadosSelecionados
                    .filter(p => p.categoria === 'LOCALIDADE0')
                    .map(p => p.id),
                idNivel1: this.resultadosSelecionados
                    .filter(e => e.categoria === 'LOCALIDADE1')
                    .map(e => e.id),
                idNivel2: this.resultadosSelecionados
                    .filter(m => m.categoria === 'LOCALIDADE2')
                    .map(m => m.id)
            };

            this.tags = [...this.resultadosSelecionados];

            if (this.biomaSelecionado.id) {
                this.tags.push({
                    id: this.biomaSelecionado.codigo,
                    nome: this.biomaSelecionado.nome,
                    codigo: 'BIOMA'
                });
                filtros.idBiomas = [this.biomaSelecionado.id];
            }

            if (this.localidadeNivel0Selecionada && this.localidadeNivel0Selecionada.id) {
                const localidadeNivel0 = {
                    id: this.localidadeNivel0Selecionada.id,
                    nome: `${this.localidadeNivel0Selecionada.sigla}`,
                    codigo: 'LOCALIDADE0'
                };
                this.tags.push(localidadeNivel0);
                filtros.idNivel0 = this.localidadeNivel0Selecionada.id;
            } else {
                filtros.idNivel0 = '';
            }

            if (this.localidadeNivel1Selecionada && this.localidadeNivel1Selecionada.id) {
                const localidadeNivel1 = {
                    id: this.localidadeNivel1Selecionada.id,
                    nome: `${this.localidadeNivel1Selecionada.sigla}`,
                    codigo: 'LOCALIDADE1'
                };
                this.tags.push(localidadeNivel1);
                filtros.idNivel1 = this.localidadeNivel1Selecionada.id;
            } else {
                filtros.idNivel1 = '';
            }

            if (this.localidadeNivel2Selecionada) {
                const localidadeNivel2 = {
                    id: this.localidadeNivel2Selecionada.id,
                    nome: `${this.localidadeNivel2Selecionada.nome}`,
                    codigo: 'LOCALIDADE2'
                };
                this.tags.push(localidadeNivel2);
                filtros.idNivel2 = this.localidadeNivel2Selecionada.id;
            } else {
                filtros.idNivel2 = '';
            }
            this.tags.sort((a, b) => a.nome.localeCompare(b.nome));

            this.$emit('atualizar-filtro', filtros);
        },

        abrirCollapse(collapse) {
            if (collapse) {
                try {
                    const acao = this.acaoCollapse[collapse];
                    if (!this[collapse].length) {
                        this[acao.callback]();
                    }
                } catch (error) {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados.'
                    );
                    // eslint-disable-next-line no-throw-literal
                    throw `Ação não registrada para o collapse: ${collapse}, ERRRO: ${error}`;
                }
            }
        },

        removerFiltro(filtro) {
            this.tags.splice(this.tags.indexOf(filtro), 1);
            this.desmarcarFiltroPopover(filtro);
            this.aplicarFiltros();
        },

        desmarcarFiltroPopover(filtro) {
            this.resultadosSelecionados = this.resultadosSelecionados.filter(
                c => c.codigo !== filtro.codigo
            );

            if (filtro.codigo === 'BIOMA') {
                this.biomaSelecionado = '';
            }

            if (filtro.codigo === 'LOCALIDADE0') {
                this.localidadeNivel0Selecionada = {};
            }

            if (filtro.codigo === 'LOCALIDADE1') {
                this.localidadeNivel1Selecionada = '';
            }

            if (filtro.codigo === 'LOCALIDADE2') {
                this.localidadeNivel2Selecionada = '';
            }
        },

        limparFiltros() {
            [...this.tags].forEach(tag => this.removerFiltro(tag));
        },

        buscarBiomas() {
            BiomaService.buscar()
                .then(({ data }) => {
                    setTimeout(() => {
                        this.biomas = data;
                    }, 500);
                })
                .catch(error => {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados de biomas.'
                    );
                    throw error;
                });
        },

        buscarLocalidadeNivel0() {
            LocalidadeService.findNivel0()
                .then(({ data }) => {
                    setTimeout(() => {
                        this.localidadesNivel0 = data;
                        if (Object.entries(this.localidadeNivel0Selecionada).length === 0) {
                            this.localidadeNivel0Selecionada = this.localidadesNivel0[1];
                            this.buscarLocalidadeNivel1();
                        }
                    }, 500);
                })
                .catch(error => {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados dos países.'
                    );
                    throw error;
                });
        },

        buscarLocalidadeNivel1() {
            LocalidadeService.findNivel1(this.localidadeNivel0Selecionada.id)
                .then(({ data }) => {
                    this.localidadeNivel1Selecionada = null;
                    setTimeout(() => {
                        this.localidadesNivel1 = data;
                    }, 500);
                })
                .catch(error => {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados de estados.'
                    );
                    throw error;
                });
        },

        buscarLocalidadeNivel2() {
            LocalidadeService.findNivel2(this.localidadeNivel1Selecionada.id)
                .then(({ data }) => {
                    this.localidadeNivel2Selecionada = null;
                    setTimeout(() => {
                        this.localidadesNivel2 = data;
                    }, 500);
                })
                .catch(error => {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados de municipio.'
                    );
                    throw error;
                });
        },

        exibirNotify(tipo, message) {
            this.$notify[tipo]({
                message
            });
        },
        validarRotaComParametro() {
            if (this.$route.params.valor && this.$route.params.id) {
                let resultado;
                let categoria;
                let valor = this.$route.params.valor;
                let tipo = valor.substring(0, valor.indexOf('=='));
                if (tipo === 'REPRESENTANTE') {
                    let idRepresentante = this.$route.params.id;
                    categoria = tipo;
                    resultado = {
                        id: idRepresentante,
                        valor: valor.substring(valor.indexOf('==') + 2)
                    };
                }
                if (tipo === 'TERRITORIO') {
                    categoria = tipo;
                    let idTerritorio = this.$route.params.id;
                    resultado = {
                        id: idTerritorio,
                        valor: valor.substring(valor.indexOf('==') + 2)
                    };
                }
                this.adicionarResultado(resultado, categoria);
                this.aplicarFiltros();
            }
        },
        validarRotaSemParametro() {
            if (!this.$route.params.valor && !this.$route.params.id) {
                let filtros = {
                    idNivel0: null,
                    idNivel1: null,
                    idNivel2: null,
                    idBiomas: [],
                    idTerritorios: [],
                    idRepresentantes: []
                };
                this.$emit('atualizar-filtro', filtros);
            }
        },

        internacionalizarLocalidade() {
            if (this.localidadeNivel0Selecionada.sigla === 'BR') {
                this.tituloLocalidadeNivel1 = this.$t('mensagens.blocoFiltros.uteis.uf');
                this.tituloLocalidadeNivel2 = this.$t('mensagens.blocoFiltros.uteis.municipio');
            }
            if (this.localidadeNivel0Selecionada.sigla === 'PY') {
                this.tituloLocalidadeNivel1 = this.$t('mensagens.blocoFiltros.uteis.paraguaiNivel1');
                this.tituloLocalidadeNivel2 = this.$t('mensagens.blocoFiltros.uteis.paraguaiNivel2');
            }
            if (this.localidadeNivel0Selecionada.sigla === 'AR') {
                this.tituloLocalidadeNivel1 = this.$t('mensagens.blocoFiltros.uteis.argentinaNivel1');
                this.tituloLocalidadeNivel2 = this.$t('mensagens.blocoFiltros.uteis.argentinaNivel2');
            }
        },
        placeholderPais() {
            if (this.usuarioLogado.paisGrupo === this.ambientes.PARAGUAY) {
                return this.$t('mensagens.blocoFiltros.uteis.placeholderAgricolaParaguai');
            } else {
                return this.$t(`mensagens.blocoFiltros.uteis.placeholder`);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.filtros {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
}

.filtros-avancados-popover__select {
    display: flex;
    justify-content: start;
    gap: 25px;
    min-height: 60px;
}

.el-collapse-item div p {
    font-size: 14px;
    margin-bottom: 0.5rem;
    font-weight: 500;
}

.pesquisa-inteligente__container {
    width: 100%;
    height: 42px;
    border-radius: 5px;
    background: var(--white);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    position: relative;
    margin-right: 10px;
}

.pesquisa-inteligente__barra-pesquisa {
    height: 100%;
    display: flex;
    justify-content: center;

    i.el-icon-search {
        color: var(--primary);
        font-size: 25px;
        font-weight: bold;
        display: flex;
        align-items: center;
        margin: 0 8px;
    }

    input {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        border-radius: 5px;
        color: var(--primary);
    }
}

.pesquisa-inteligente__resultado {
    position: absolute;
    width: 100%;
}

.pesquisa-inteligente__ul {
    list-style: none;
    padding: 8px 0 8px 24px;
    position: relative;
    z-index: 42;
    margin-top: 5px;
    border-radius: 5px;
    background-color: var(--white);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

    li {
        padding-left: 18px;
        margin-top: 5px;
        cursor: pointer;
    }
}

.pesquisa-inteligente__categoria {
    font-weight: bold;
}

.filtros-avancados__cabecalho {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.filtros-avancados__aplicar-filtro {
    cursor: pointer;
    border: 1px solid #eeeeee;
    border-radius: 20px;
    padding: 4px 8px;
    color: var(--primary);
}

.pesquisa-inteligente-novo-monitoramento__filtros-selecionados {
    display: flex;
    align-items: center;
    gap: 4px;
}

.filtros-selecionados__limpar {
    cursor: pointer;
}

.el-collapse-item__biomas {
    display: flex;
    flex-wrap: wrap;
    gap: 16px 32px;
}
</style>
